export const countryCodeMap: Record<string, string> = {
  Turkey: "tr",
  Canada: "ca",
  Germany: "de",
  Ireland: "ie",
  Italy: "it",
  Japan: "jp",
  "Korea, South": "kr",
  Netherlands: "nl",
  Poland: "pl",
  Qatar: "qa",
  Spain: "es",
  Sweden: "se",
  Switzerland: "ch",
  "United Arab Emirates": "ae",
  "United Kingdom": "gb",
  "United States": "us",
  "Other European Countries": "",
  "Other Middle East Countries": "",
};

export const getCountryFilterBy = (country?: string | null): string => {
  if (!country) return "";
  const normalized = country.trim();
  if (/^[a-z]{2}$/i.test(normalized)) {
    return normalized.toLowerCase();
  }
  return countryCodeMap[country] ?? "";
};
